import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationState } from '../_reducers/notification.reducers';

const getFieldFeatureState =
  createFeatureSelector<NotificationState>('notification');

export const getNotificationLoading = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.notificationLoading
);

/**
 * Select fields
 */
export const getNotifications = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.notifications
);

/**
 * Select webhooks
 */
 export const getWebhooks = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.webhooks
);

/**
 * Select operations
 */
export const getNotificationOperations = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.operations
);

/**
 * Select notification
 */
export const getNotification = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.notification
);

/**
 * Select test notification
 */
export const getTestNotification = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.testNotification
);

/**
 * Select exists notification
 */
export const existsNotification = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.existsNotification
);

/**
 * Select view notification error
 */
export const viewNotificationErrors = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.viewNotificationError
);

/**
 * Select error
 */
export const getError = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.error
);
export const getExecuteVerificationSuccess = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.executeVerificationSuccess
);
export const getExecuteVerificationError = createSelector(
  getFieldFeatureState,
  (state: NotificationState) => state.executeVerificationError
);
